module.exports = __webpack_public_path__ + "img/doom_bringer.360a1950.png";